<template>
  <v-btn outlined
         small
         id="btn_add_seats">
    Add Seats
    <v-dialog v-model="showDialog"
              activator="#btn_add_seats"
              width="500">
      <v-form @submit.prevent="submit">
        <v-card>
          <v-card-title>
            Add Seats
          </v-card-title>
          <v-card-text>

            <p>
              Right now, you have used up {{ team.licensed_users }} of the {{ team.max_users | pluralize('seat') }} you have.
            </p>

            <v-text-field v-model.number="form.new_seats"
                          label="Add Seats"
                          placeholder=" "
                          type="number"
                          min="1"
                          step="1"
                          autocomplete="off"
                          :rules="[rules.required]"
                          :error-messages="form.errors.get('new_seats')">
            </v-text-field>

          </v-card-text>

          <v-card-actions>
            <v-btn type="submit"
                   color="primary">
              Proceed to Checkout
            </v-btn>
            <v-btn outlined
                   @click.prevent="showDialog = false">
              Cancel
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-btn>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import formValidation from '../../../plugins/formValidation';

export default {
  mixins: [formValidation],
  data() {
    return {
      form: new Form({
        new_seats: 1,
      }),
      showDialog: false,
    }
  },
  computed: {
    ...mapGetters([
      'activeUsers',
      'team',
      'user',
      'users',
    ])
  },
  methods: {
    submit() {
      const newSeatsQuota = this.team.max_users + this.form.new_seats;
      this.$router.push({name: 'change_subscription.review', query: {new_seats_quota: newSeatsQuota}});
    }
  }
}
</script>
